import { resTol } from '@/tools/public';
export default {
  name: 'CodeDataPickerCpt',
  components: {},
  props: {
    codeType: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      show: false,
      isLoading: false,
      dataType: this.codeType,
      dataRes: [],
      columnsFieldNames: {
        text: 'codeName',
        value: 'code'
      }
    };
  },
  methods: {
    showView(dataType) {
      if (dataType) {
        this.dataType = dataType;
      }
      this.show = true;
      this.isLoading = true;
      resTol.initReqCodeListResCb([this.dataType], res => {
        for (const code of res) {
          if (code.codeType === this.dataType) {
            this.dataRes = code.codeList;
          }
        }
        this.isLoading = false;
      });
    },
    onConfirmClick({
      selectedValues,
      selectedOptions
    }) {
      this.$emit('onSelectedChange', selectedValues, selectedOptions);
      this.show = false;
    },
    onCancelClick() {
      this.show = false;
    }
  }
};